var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.3299V46.1399C1 47.9599 2.47 49.4299 4.29 49.4299H31.04C32.86 49.4299 34.33 47.9599 34.33 46.1399V17.3299C34.33 15.5099 32.86 14.0399 31.04 14.0399H4.29C2.47 14.0399 1 15.5099 1 17.3299Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.3299V46.1299C1 47.9499 2.48 49.4199 4.29 49.4199H31.03C32.85 49.4199 34.32 47.9399 34.32 46.1299V17.3299C34.32 15.5099 32.84 14.0399 31.03 14.0399H4.29C2.48 14.0399 1 15.5099 1 17.3299Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1803 34.8899H17.6703V49.4299H9.57031V36.4999C9.57031 35.6099 10.2903 34.8899 11.1803 34.8899Z",
    fill: "#FFCF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1599 34.8899H17.6699V49.4299H25.7699V36.4999C25.7599 35.6099 25.0399 34.8899 24.1599 34.8899Z",
    fill: "#FFCF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1803 34.8899H17.6703V49.4299H9.57031V36.4999C9.57031 35.6099 10.2903 34.8899 11.1803 34.8899Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1599 34.8899H17.6699V49.4299H25.7699V36.4999C25.7599 35.6099 25.0399 34.8899 24.1599 34.8899Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8907 27.9299H7.4707",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8907 21.96H7.4707",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4414 27.9299H27.8614",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4414 21.96H27.8614",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6699 17.3299V46.1399C17.6699 47.9599 19.1399 49.4299 20.9599 49.4299H47.7099C49.5299 49.4299 50.9999 47.9599 50.9999 46.1399V17.3299C50.9999 15.5099 49.5299 14.0399 47.7099 14.0399H20.9599C19.1399 14.0399 17.6699 15.5099 17.6699 17.3299Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6699 17.3299V46.1299C17.6699 47.9499 19.1499 49.4199 20.9599 49.4199H47.6999C49.5199 49.4199 50.9899 47.9399 50.9899 46.1299V17.3299C50.9899 15.5099 49.5099 14.0399 47.6999 14.0399H20.9599C19.1399 14.0399 17.6699 15.5099 17.6699 17.3299Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8405 34.8899H34.3305V49.4299H26.2305V36.4999C26.2405 35.6099 26.9605 34.8899 27.8405 34.8899Z",
    fill: "#FFCF00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8201 34.8899H34.3301V49.4299H42.4301V36.4999C42.4301 35.6099 41.7101 34.8899 40.8201 34.8899Z",
    fill: "#FFCF00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8405 34.8899H34.3305V49.4299H26.2305V36.4999C26.2405 35.6099 26.9605 34.8899 27.8405 34.8899Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8201 34.8899H34.3301V49.4299H42.4301V36.4999C42.4301 35.6099 41.7101 34.8899 40.8201 34.8899Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5606 27.9299H24.1406",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5606 21.96H24.1406",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1113 27.9299H44.5313",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1113 21.96H44.5313",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0209 29.8499C33.554 29.8499 39.6609 23.7431 39.6609 16.2099C39.6609 8.67678 33.554 2.56995 26.0209 2.56995C18.4877 2.56995 12.3809 8.67678 12.3809 16.2099C12.3809 23.7431 18.4877 29.8499 26.0209 29.8499Z",
    fill: "#FFCF00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0209 29.8499C33.554 29.8499 39.6609 23.7431 39.6609 16.2099C39.6609 8.67678 33.554 2.56995 26.0209 2.56995C18.4877 2.56995 12.3809 8.67678 12.3809 16.2099C12.3809 23.7431 18.4877 29.8499 26.0209 29.8499Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1406 13.94H28.2906V11.09C28.2906 10.39 27.7206 9.82996 27.0306 9.82996H25.0106C24.3106 9.82996 23.7506 10.4 23.7506 11.09V13.94H20.9006C20.2006 13.94 19.6406 14.5 19.6406 15.2V17.22C19.6406 17.92 20.2106 18.48 20.9006 18.48H23.7506V21.33C23.7506 22.03 24.3106 22.59 25.0106 22.59H27.0306C27.7306 22.59 28.2906 22.03 28.2906 21.33V18.48H31.1406C31.8406 18.48 32.4006 17.91 32.4006 17.22V15.2C32.4006 14.5 31.8306 13.94 31.1406 13.94Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1406 13.94H28.2906V11.09C28.2906 10.39 27.7206 9.82996 27.0306 9.82996H25.0106C24.3106 9.82996 23.7506 10.4 23.7506 11.09V13.94H20.9006C20.2006 13.94 19.6406 14.5 19.6406 15.2V17.22C19.6406 17.92 20.2106 18.48 20.9006 18.48H23.7506V21.33C23.7506 22.03 24.3106 22.59 25.0106 22.59H27.0306C27.7306 22.59 28.2906 22.03 28.2906 21.33V18.48H31.1406C31.8406 18.48 32.4006 17.91 32.4006 17.22V15.2C32.4006 14.5 31.8306 13.94 31.1406 13.94Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOn);
export default __webpack_public_path__ + "static/media/AddOn.68be243fd1c0b34b608c7b9015d72aec.svg";
export { ForwardRef as ReactComponent };